<template>
  <aw-input-version2
    v-if="modelValue.version2"
    v-model.trim="inputValue"
    :has-error="hasError"
    :is-focused="isFocused"
    :has-success="hasSuccess"
    :has-label="Boolean(modelValue.label && screenRange['mobile-max']) || modelValue.labelAttrs.isFloatingLabel && (modelValue.labelAttrs.isFloatingLabelOnlyMobile ? screenRange['mobile-max'] : true)"
    :widget-props="modelValue.widgetProps"
    :widget-attrs="modelValue.widgetAttrs"
    :widget-icon-attrs="smartWidgetIconAttrs"
    :type="modelValue.type"
    :special-type="modelValue.specialType"
    :is-invalid="isInvalid"
    :is-required="isRequired"
    :row-unique-id="rowUniqueId"
    :floating-label-text="modelValue.labelAttrs.isFloatingLabel && (modelValue.labelAttrs.isFloatingLabelOnlyMobile ? screenRange['mobile-max'] : true) ? modelValue.label : null "
    :max="modelValue?.widgetProps?.max"
    :min="modelValue?.widgetProps?.min"
    :step="modelValue?.widgetProps?.step"
    @blur="onBlur"
  >
    <template #prefix>
      <slot name="prefix" />
    </template>
    <template #postfix>
      <slot name="postfix" />
    </template>
  </aw-input-version2>
  <aw-input
    v-else
    v-model.trim="inputValue"
    :has-error="hasError"
    :is-focused="isFocused"
    :has-success="hasSuccess"
    :has-label="Boolean(modelValue.label)"
    :widget-props="modelValue.widgetProps"
    :widget-attrs="modelValue.widgetAttrs"
    :widget-icon-attrs="smartWidgetIconAttrs"
    :type="modelValue.type"
    :input-size="modelValue.inputSize"
    :special-type="modelValue.specialType"
    :is-invalid="isInvalid"
    :is-required="isRequired"
    :row-unique-id="rowUniqueId"
    @blur="onBlur"
  >
    <template #prefix>
      <slot name="prefix" />
    </template>
    <template #postfix>
      <slot name="postfix" />
    </template>
  </aw-input>
</template>

<script>
  import { mapState } from 'pinia';
  import AwInput from '../../Common/AwInput';

  import formMixin from '~~/common/mixins/formMixin';
  import AwInputVersion2 from '~~/common/components/Common/AwInputVersion2';
  import { useUserInterfaceStore } from '~~/common/stores/userInterface';

  export default {
    name: 'AwFormInput',
    components: {
      AwInputVersion2,
      AwInput,
    },
    mixins: [formMixin],
    props: {
      isFocused: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState(useUserInterfaceStore, {
        screenRange: state => state.mediaQueries,
      }),
      inputValue: {
        get () {
          return this.modelValue.model;
        },
        set (value) {
          this.modelValueData.model = value;
          if (this.blur) {
            this.validateTheRow();
          }
          this.emitData(this.modelValueData);
        },
      },
      smartWidgetIconAttrs () {
        let name = false;
        if (this.modelValue.widgetIconAttrs) {
          if (this.modelValue.widgetIconAttrs.name) {
            name = this.modelValue.widgetIconAttrs.name;
          } else if (this.rowValidator && this.hasSuccess) {
            name = 'check-circle-24';
          } else if (this.rowValidator) {
            name = 'alert-24';
          }
          return {
            name,
            ...this.modelValue.widgetIconAttrs,
          };
        } else {
          return {};
        }
      },
    },
  };
</script>
